import { BASE_PATH, PATH_BASE_EXTENSION_USER } from "../../utils/constants";
import { getToken } from "../Auth/token";
import axios from "axios";

const baseUrl = `${BASE_PATH}${PATH_BASE_EXTENSION_USER}/media`;

export function apiList(data) {
    const config = { headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}` } };
    return axios.get(`${baseUrl}/list?limit=${data.limit}&offset=${data.offset}`, config)
}

export function apiGetMedia(relativePath) {
    const config = { headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}` } };
    return axios.get(`${baseUrl}/get?relative_path=${encodeURIComponent(relativePath)}`, config);
}

export function apiGetMediaElement(relativePath) {
    const config = { headers: { 'Authorization': `Bearer ${getToken()?.primaryUser?.token}` } };
    return axios.get(`${baseUrl}/get-element?relative_path=${encodeURIComponent(relativePath)}`, config);
}